<fip-reduction-in-the-value-of-oee-below-x-form
  (formSubmit)="onFormSubmit($event)"
/>
